module.exports = __webpack_public_path__ + "static/media/compra-segura-login.8be1b0db.svg";